/*********************** Custom JS for Boost AI Search & Discovery  ************************/
(function() {
  function syncBoostLabelsAndContrast() {

    document.querySelectorAll('h3.boost-sd__filter-option-heading').forEach(function(heading) {
      var replacement = document.createElement('h2');
      Array.prototype.forEach.call(heading.attributes, function(attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      var computed = window.getComputedStyle(heading);
      ['font-family', 'font-size', 'font-weight', 'line-height', 'color', 'margin-top', 'margin-bottom', 'text-transform'].forEach(function(property) {
        replacement.style.setProperty(property, computed.getPropertyValue(property));
      });
      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }
      heading.parentNode.replaceChild(replacement, heading);
    });
    // 1. Sync search input label
    document.querySelectorAll('input[name="q"], input[type="search"]').forEach(function(input) {
      if (input.id && input.id.indexOf('boost-sd') > -1) {
        var form = input.form || input.closest('form');
        if (form) {
          var label = form.querySelector('label');
          if (label && label.getAttribute('for') !== input.id) {
            label.setAttribute('for', input.id);
          }
        }
        if (!input.getAttribute('aria-label')) {
          input.setAttribute('aria-label', input.placeholder || 'Search');
        }
      }
    });

    // 2. Enforce high contrast on compare-at (strikethrough) prices
    document.querySelectorAll('s, del, strike, [class*="compare"], [class*="old-price"], .boost-sd__product-price--compare, .boost-sd__format-currency--price-compare').forEach(function(el) {
      if (el.style.color !== '#42261b') {
        el.style.setProperty('color', '#42261b', 'important');
      }
      if (el.style.opacity !== '1') {
        el.style.setProperty('opacity', '1', 'important');
      }
      el.querySelectorAll('*').forEach(function(child) {
        if (child.style.color !== '#42261b') {
          child.style.setProperty('color', '#42261b', 'important');
        }
        if (child.style.opacity !== '1') {
          child.style.setProperty('opacity', '1', 'important');
        }
      });
    });

    // 3. Enforce high contrast on filter amounts & counts
    document.querySelectorAll('.boost-sd__filter-option-item-amount, [class*="option-item-amount"], [class*="item-amount"], [class*="filter-item-count"], [class*="filter-item-total"], [class*="filter-value-count"]').forEach(function(el) {
      if (el.style.color !== '#42261b') {
        el.style.setProperty('color', '#42261b', 'important');
      }
      if (el.style.opacity !== '1') {
        el.style.setProperty('opacity', '1', 'important');
      }
      if (el.style.fontWeight !== '600') {
        el.style.setProperty('font-weight', '600', 'important');
      }
    });

    // 4. Enforce high contrast on footer subscribe button
    var footerSub = document.getElementById('footer-subscribe');
    if (footerSub) {
      if (footerSub.style.color !== 'rgb(34, 19, 12)' && footerSub.style.color !== '#22130c') {
        footerSub.style.setProperty('color', '#22130c', 'important');
        footerSub.style.setProperty('background-color', '#bf885d', 'important');
        footerSub.style.setProperty('opacity', '1', 'important');
        footerSub.style.setProperty('font-weight', '600', 'important');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBoostLabelsAndContrast);
  } else {
    syncBoostLabelsAndContrast();
  }

  if (window.MutationObserver) {
    var isRunning = false;
    var observer = new MutationObserver(function() {
      if (isRunning) return;
      isRunning = true;
      syncBoostLabelsAndContrast();
      setTimeout(function() { isRunning = false; }, 100);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['id', 'class', 'style']
    });
  }
})();